import React, { useState, useEffect, useRef } from "react";
import axiosClient from "../../../utils/axiosClient";
import { urlValoresMensal } from "../../../utils/constants";
import { IonLabel, IonInput } from "@ionic/react";
import Chart from "chart.js/auto";

export default function ValoresMensal({
  totalClientes,
  totalAgendamentos,
  dataBusca
}) {
  const chartRef = useRef(null);
  const [chart, setChart] = useState(null);
  const [mesSelecionado, setMesSelecionado] = useState(() => {
    // Formato inicial: YYYY-MM do mês atual
    const hoje = new Date();
    return `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, "0")}`;
  });
  const [valorTotalMes, setValorTotalMes] = useState(0);

  const listaEmpresas = async () => {
    try {
      const response = await axiosClient.post(urlValoresMensal, {
        dia: dataBusca,
        mes: mesSelecionado // Envia o mês selecionado
      });
      totalClientes(response?.data?.total_clientes?.total);

      // Soma dos agendamentos semanais
      const somaTotalAgendamentos = response?.data?.agendamentos_semana
        ? response.data.agendamentos_semana.reduce(
            (acc, item) => acc + item.total,
            0
          )
        : 0;
      totalAgendamentos(somaTotalAgendamentos);

      // Valor total do mês
      setValorTotalMes(response?.data?.valor_total_mes ?? 0);

      // Gráfico de valores por dia do mês
      if (response.data.valores_por_dia_mes) {
        const cores = ["#141458", "#000000", "#D2F660", "#4B66E3", "#E52730", "#F98715", "#B165C9"];
        const labels = response.data.valores_por_dia_mes.map(
          (item) => `Dia ${item.dia}`
        );
        const data = response.data.valores_por_dia_mes.map(
          (item) => item.total
        );
        const backgroundColors = cores;

        updateChart(labels, data, backgroundColors);
      } else {
        throw new Error("No data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const updateChart = (labels, data, backgroundColors) => {
    if (chart) {
      chart.destroy();
    }

    const ctx = chartRef.current.getContext("2d");

    const newChart = new Chart(ctx, {
      type: "bar", // Alterado para barra
      data: {
        labels: labels,
        datasets: [
          {
            label: "Valores por Dia do Mês",
            data: data,
            backgroundColor: backgroundColors,
            barThickness: 25,
            borderRadius: 20,
          },
        ],
      },
      options: {
        indexAxis: "y", // Barra horizontal
        aspectRatio: 1.5,
        scales: {
          x: {
            beginAtZero: true,
            grid: {
              display: false,
              drawTicks: false,
            },
            ticks: {
              display: true,
              color: "#141458",
              drawTicks: false,
            },
          },
          y: {
            beginAtZero: true,
            grid: {
              display: false,
              drawTicks: false,
            },
            ticks: {
              display: true,
              color: "#141458",
              drawTicks: false,
            },
          },
        },
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: false,
          },
        },
      },
    });
    setChart(newChart);
  };

  useEffect(() => {
    listaEmpresas();
    setTimeout(() => {}, 1000);
    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  }, [dataBusca, mesSelecionado]); // Atualiza quando o mês muda

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <IonLabel>
          <h2
            className="ion-text-center"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            Valores recebidos no mês
          </h2>
        </IonLabel>
        <IonInput
          type="month"
          value={mesSelecionado}
          onIonChange={e => setMesSelecionado(e.detail.value)}
          style={{ maxWidth: 200, margin: "0 auto", display: "block" }}
        />
        <canvas
          id="myChart"
          ref={chartRef}
          style={{ width: "95%", height: "auto", marginTop: 20 }}
        ></canvas>
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <strong>Total do mês:</strong> R$ {valorTotalMes}
        </div>
      </div>
    </div>
  );
}
